/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

/**
 * Runtime Terms
 */
export const runtimeTerms = {
	appError: {
		info: "ui:appError#info",
		contact: "ui:appError#contact"
	}
};
